import { render } from "./CustomSelectOneHorseOrigin.vue?vue&type=template&id=342d0962"
import script from "./CustomSelectOneHorseOrigin.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneHorseOrigin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__